import { Alert, AlertTitle } from '@material-ui/lab'
import React from 'react'
import { IRejectionCause } from 'types'

interface Props {
  rejectionCause?: IRejectionCause
  status: number
}

const RejectionData = (props: Props) => {
  const { rejectionCause, status } = props
  return (
    <React.Fragment>
      {rejectionCause && (
        <Alert
          className="w-full"
          severity="error"
          variant="outlined"
          style={{
            backgroundColor: '#ebebeb',
            color: '#000000',
          }}
        >
          <AlertTitle>{`Motivo ${status === 5 ? 'Pendiente' : 'de rechazo'}`}</AlertTitle>
          {rejectionCause.rejectionCauseCode}
          <strong>{` - ${rejectionCause.name}`}</strong>
          <br />
          {rejectionCause.description ?? ''}
        </Alert>
      )}
    </React.Fragment>
  )
}

export default RejectionData
